import React from "react";
import { useTranslation } from "react-i18next";
import "./addDashboards.scss";

function AddDashboards() {

  const { t } = useTranslation()

  return (
    <div className="container-add-dashboards">
      <div className="texts-add-dashboards">
        <h1>{t("whitelabel.dashboard.title")}</h1>
        <p>{t("whitelabel.dashboard.section_text_1")}</p>
        <p>{t("whitelabel.dashboard.section_text_2")}</p>
      </div>
    </div>
  );
}

export default AddDashboards;
